/**
*
*   Customer API
*       - A Layer for Customer data Hooked between Storefront + Shopify Tools
*
**/

//
import Config from '@/config';

/**
*
*   Article Helper Class
*
*
**/
const Article = {

    //Get a Handle from a String
    handle:     (string) => string.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '') .replace(/-+$/, ''),

    //Trin the Excerpt
    excerpt:    (article) => ( article.excerpt || article.content.split(' ').slice(0,30).join(' ') + '...' ),

    //Article Validations
    is: {
        video:  (article) => ( /className=\"([0-9a-z\s]+)?video([0-9a-z\s]+)?\"/gi.test( article.contentHtml ) || article.video )
    }

};


//Output
export default Article;